import React, { Component } from 'react';

import Header from '../../components/Header/Header';
import Navigation from '../../components/Navigation/Navigation';
import faqHeaderBg from '../../assets/images/faqBg.png'
import Footer from '../../components/Footer'
import CategoryItemIcon from "../../components/Calculator-board/Category-item/Category-item-icon";
import director from '../../assets/images/director.jpg'
import { getTranslate } from 'react-localize-redux';
import { connect } from 'react-redux'
// import {FaqContent}  from './faqContent'

import './AboutUs.css'

class CategoryDescription extends Component {
    constructor(props) {
        super(props);
        this.state = {
            content: []
        }
    }

    componentDidMount() {
        window.scrollTo(0, 0);
    }


    render() {
        return (
            <div className="about-us-container">
                <div className="Head">
                    <Header />
                    <Navigation />
                </div>
                <div className="about-us-container-header">
                    <div className="about-us-header-wrapper"></div>
                    <div className="about-us-header-content">
                        <div className="about-us-header-text">
                            <h1>{this.props.translate("about-us-header-title")}</h1>
                            {/* <h5>{this.props.translate("PolicySearchPortalByIndividualPersons")}</h5> */}
                        </div>
                    </div>
                </div>

                <div className="about-us-content">
                    <div className="about-us-content-text">
                        <h3>
                            {this.props.translate("about-us-text-head-1")}
                        </h3>
                        <span>
                            {this.props.translate("about-us-text-content-1-1")}
                        </span>
                        <span>
                            {this.props.translate("about-us-text-content-1-2")}
                        </span>
                    </div>
                    <div className="about-us-content-logos">
                        <div className="about-us-content-logos-header">
                            <h3>
                                {this.props.translate("about-us-text-head-2")}
                            </h3>
                        </div>
                        <div className="founders-wrapper">
                            <img src={'https://arc.tpl.ge/webpagelogos/320.png'} />
                        </div>
                    </div>

                    <div className="about-us-content-text">
                        <img src={director} height={150} align="left" id="directorImage"  />
                        <h3>{this.props.translate("about-us-text-head-3")}</h3>
                        <span>
                            {this.props.translate("about-us-text-content-3-1")}
                        </span>
                        <span>
                            {this.props.translate("about-us-text-content-3-2")}
                        </span>
                        <span>
                            {this.props.translate("about-us-text-content-3-3")}
                        </span>
                        <span>
                            {this.props.translate("about-us-text-content-3-4")}
                        </span>
                    </div>
                </div>

                <Footer />
            </div>
        )
    }
}

const mapStateToProps = state => ({
    translate: getTranslate(state.locale),

})
export default connect(mapStateToProps)(CategoryDescription)



// WEBPACK FOOTER //
// ./src/pages/AboutUs/AboutUs.js